import { DashboardManagerApi } from "@/api";

export async function getUserInfo() {
  const { data } = await DashboardManagerApi.getUserInfo();
  return data;
}

export async function getRanking(userActiveRole) {
  const { data } = await DashboardManagerApi.getRanking(userActiveRole);
  return data;
}

export async function getAveragePerformance(userActiveRole) {
  const { data } = await DashboardManagerApi.getAveragePerformance(
    userActiveRole
  );
  return data;
}

export async function getProgress(userActiveRole) {
  const { data } = await DashboardManagerApi.getProgress(userActiveRole);
  return data;
}

export async function getCorrectAnswersPercentage(userActiveRole) {
  const { data } = await DashboardManagerApi.getCorrectAnswersPercentage(
    userActiveRole
  );
  return data;
}

export async function getTeamInfo(userActiveRole) {
  const { data } = await DashboardManagerApi.getTeamInfo(userActiveRole);
  return data;
}

export async function getTeamLastTopics(userActiveRole) {
  const { data } = await DashboardManagerApi.getTeamLastTopics(userActiveRole);
  return data;
}
